import React from 'react';
import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import {
  IngProjectsPage,
  IngProjectsEdit,
  IngProjectsDetailPage,
  IngProjectsSettingsPage,
  IngProjectsMyApplicationsPage,
  IngProjectsAssignedPage,
  IngProjectsStudentsPage,
  IngProjectsStudentAssignmentPage,
  IngProjectsActiveStudentsPage,
  IngProjectsActiveStudentsEdit,
  IngProjectsActiveStudentsCreate,
  IpChangeRequestsPage,
  IpPanelStoryPage,
} from '../pages/CMSPages';

const IngProjectsRoutes = () => (
  <>
    {/* Inžinierske projekty - zoznam (každý prihlásený) */}
    <Route
      path={routes.cmsIngProjects}
      element={
        <CMSWrapper>
          <IngProjectsPage />
        </CMSWrapper>
      }
    />

    {/* Inžinierske projekty - vytvorenie (len učiteľ) */}
    <Route
      path={routes.cmsIngProjectsCreate}
      element={
        <CMSWrapper permissions={['ing-projects-project-guarantee']}>
          <IngProjectsEdit mode="create" />
        </CMSWrapper>
      }
    />

    {/* Inžinierske projekty - úprava (len učiteľ) */}
    <Route
      path={routes.cmsIngProjectsEdit(':projectId')}
      element={
        <CMSWrapper permissionsAny={['ing-projects-project-guarantee', 'ing-projects-admin']}>
          <IngProjectsEdit mode="edit" />
        </CMSWrapper>
      }
    />

    {/* Inžinierske projekty - priradenie študentov (admin + garant) */}
    <Route
      path={routes.cmsIngProjectsStudentAssignment}
      element={
        <CMSWrapper permissionsAny={['ing-projects-study-program-guarantee', 'ing-projects-assignments', 'ing-projects-admin']}>
          <IngProjectsStudentAssignmentPage />
        </CMSWrapper>
      }
    />

    {/* Inžinierske projekty - nastavenia (len admin) */}
    <Route
      path={routes.cmsIngProjectsSettings}
      element={
        <CMSWrapper permissions={['ing-projects-admin']}>
          <IngProjectsSettingsPage />
        </CMSWrapper>
      }
    />

    {/* Inžinierske projekty - panel story (admin + učiteľ) */}
    <Route
      path={routes.cmsIngProjectsPanelStory(':projectId')}
      element={
        <CMSWrapper permissions={['ing-projects-project-guarantee', 'ing-projects-admin']}>
          <IpPanelStoryPage />
        </CMSWrapper>
      }
    />

    {/* Vybrané projekty - moje prihlášky (len študent) */}
    <Route
      path={routes.cmsIngProjectsMyApplications}
      element={
        <CMSWrapper permissions={['ing-projects-student']}>
          <IngProjectsMyApplicationsPage />
        </CMSWrapper>
      }
    />

    {/* Priradené projekty (len študent) */}
    <Route
      path={routes.cmsIngProjectsAssigned}
      element={
        <CMSWrapper permissions={['ing-projects-student']}>
          <IngProjectsAssignedPage />
        </CMSWrapper>
      }
    />

    {/* Inžinierske projekty - študenti/záujemcovia (len učiteľ) */}
    <Route
      path={routes.cmsIngProjectsStudents(':projectId')}
      element={
        <CMSWrapper permissions={['ing-projects-project-guarantee']}>
          <IngProjectsStudentsPage />
        </CMSWrapper>
      }
    />

    {/* Inžinierske projekty - žiadosti o zmenu (učiteľ + garant + admin) */}
    <Route
      path={routes.cmsIngProjectsChangeRequests}
      element={
        <CMSWrapper permissionsAny={['ing-projects-change-requests', 'ing-projects-student']}>
          <IpChangeRequestsPage />
        </CMSWrapper>
      }
    />

    {/* Inžinierske projekty - detail (každý prihlásený) */}
    <Route
      path={routes.cmsIngProjectsDetail(':projectId')}
      element={
        <CMSWrapper>
          <IngProjectsDetailPage />
        </CMSWrapper>
      }
    />

    {/* Inžinierske projekty - zoznam aktívnych študentov (garant inž. projektu) */}
    <Route
      path={routes.cmsIngPorjectsActiveStudents}
      element={
        <CMSWrapper permissionsAny={['ing-projects-project-guarantee', 'ing-projects-study-program-guarantee', 'ing-projects-admin']}>
          <IngProjectsActiveStudentsPage />
        </CMSWrapper>
      }
    />

    {/* Inžinierske projekty - úprava priradenia aktívneho študenta (len admin) */}
    <Route
      path={`${routes.cmsIngPorjectsActiveStudents}/:studentId/edit`}
      element={
        <CMSWrapper permissions={['ing-projects-admin']}>
          <IngProjectsActiveStudentsEdit />
        </CMSWrapper>
      }
    />

    {/* Inžinierske projekty - vytvorenie priradenia aktívneho študenta (len admin) */}
    <Route
      path={routes.cmsIngProjectStudentsAdd}
      element={
        <CMSWrapper permissions={['ing-projects-admin']}>
          <IngProjectsActiveStudentsCreate />
        </CMSWrapper>
      }
    />
  </>
);

export default IngProjectsRoutes;
